import { Carousel } from "react-responsive-carousel";
import { useEffect } from "react";
import "./Slider.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useState } from "react";
const Slider = () => {
  useEffect(() => {
    document.getElementById("vid").play();
    setTimeout(() => {
      var vidHeight = document.getElementById("vid").clientHeight;
      document.getElementById("overlay").style.height = `${vidHeight}px`;
    }, 4890);
  }, []);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <div className="slider">
      <Carousel
        showArrows={true}
        showThumbs={false}
        showStatus={false}
        autoPlay={true}
        interval={3000}
      >
        <div style={{ postion: "relative" }} class="video-container">
          <div id="overlay"></div>
          <video loop autoplay muted id="vid">
            <source src={require("../../Assets/video.mp4")} type="video/mp4" />
          </video>
        </div>
      </Carousel>
      <div className="title">
        <img src={require("../../Assets/bismilah.png")} alt="" />

        <h1 className="company">
          {rtl
            ? `مرحبا بكم في مكة والمدينة القابضة المحدودة `
            : fr
            ? "Bienvenue à Mecque & la Médine holdings ltd"
            : `WELCOME TO MAKKAH & AL MADINAH HOLDINGS LTD`}
        </h1>
      </div>
    </div>
  );
};

export default Slider;
